import React, { useState, useEffect } from 'react';
import { api_url } from "../globalFunction/global_string";
import DataTable from 'react-data-table-component';
import { SiteTitle } from "../SiteTitle";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { formatDate } from "../globalFunction/response_action";
import '../FetchData.css';
import { useNavigate } from 'react-router-dom';

const MySwal = withReactContent(Swal);


function HistoryTrackingList() {
    const [trackingData, setTrackingData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    const groupByAttributes = (reports) => {
        const grouped = {};
        reports.forEach((report) => {

            const groupKey = `${report.build_date}-${report.projectName}-${report.projectStartTime}-${report.projectEndTime}`;

            if (!grouped[groupKey]) {
                grouped[groupKey] = [];
            }

            grouped[groupKey].push(report);
        });
        const sortedGroupKeys = Object.keys(grouped).sort((a, b) => {
            const dateA = new Date(a.split('-')[0]);
            const dateB = new Date(b.split('-')[0]);
            return dateB - dateA;
        });
        // 使用排序後的鍵來創建一個新的物件
        const sortedGrouped = {};
        sortedGroupKeys.forEach(key => {
            sortedGrouped[key] = grouped[key];
        });

        return sortedGrouped;
    };

    const getTotalGroupCount = (data) => {
        return Object.keys(data).length;
    };

    //給讀取資料使用
    const local_net_id = localStorage.getItem('login_user_net_id');
    const local_unit_id = localStorage.getItem('login_user_unit_id');
    const local_net_name = localStorage.getItem('login_user_net_name');
    const local_unit_name = localStorage.getItem('login_local_unit_name');
    const usertype = localStorage.getItem('login_user_type');

    const loadData = async () => {
        setIsLoading(true);
        let apiUrl = `${api_url}/api/TrackBackground/OneHistoryTrackBackgroundDetail`;
        const formData = new FormData();
        formData.append("user_type", usertype);
        formData.append("local_net_id", local_net_id);
        formData.append("local_unit_id", local_unit_id);
        formData.append("local_net_name", local_net_name);
        formData.append("local_unit_name", local_unit_name);

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Authorization": localStorage.getItem('accessToken') },
                body: formData
            });
            const data = await response.json();
            if (response.ok && data.statusCode === 200 && Array.isArray(data.row)) {
                const grouped = groupByAttributes(data.row);
                setTrackingData(grouped);

            } else {
                throw new Error('無效的回應格式');
            }
        } catch (error) {
            setError(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, []);


    const totalGroupCount = getTotalGroupCount(trackingData);
    const totalPages = Math.ceil(totalGroupCount / itemsPerPage);
    const indexOfFirstGroup = (currentPage - 1) * itemsPerPage;
    const indexOfLastGroup = Math.min(currentPage * itemsPerPage, totalGroupCount);

    const handleItemsPerPageChange = (event) => {
        const newItemsPerPage = parseInt(event.target.value, 10);
        setItemsPerPage(newItemsPerPage);
        setCurrentPage(1);
    };

    useEffect(() => {
        if (currentPage > totalPages) {
            setCurrentPage(totalPages || 1);
        }
    }, [currentPage, totalPages, itemsPerPage]);



    if (isLoading) {
        return <div>正在加載...</div>;
    }

    if (error) {
        return <div>發生錯誤: {error}</div>;
    }



    const handleModifyreport = (build_date, projectName) => {
        navigate('/FetchTrackingDetail', { state: { build_date, projectName } });
    };

    const StatusIndicator = ({ isTrackedreport }) => {
        let color;
        let statusText;
        const numericIsWAFreport = +isTrackedreport;

        switch (numericIsWAFreport) {
            case 2:
                color = 'green';
                statusText = '追蹤完成';
                break;
            case 1:
                color = 'red';
                statusText = '追蹤中';
                break;
            default:
                color = 'grey';
                statusText = '未追蹤';
                break;
        }

        return (
            <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                <div style={{
                    width: '20px',
                    height: '20px',
                    borderRadius: '50%',
                    backgroundColor: color,
                    marginRight: '5px',
                }} />
                {statusText}
            </span>
        );
    };


    return (

        <div>
            <div className="tracking-list">
                {Object.entries(trackingData).map(([groupKey, reports], index) => {
                    const report = reports[0];
                    const allReportsCompleted = reports.every(report => report.isTrackedreport === "2");
                    const anyReportInProgress = reports.some(report => report.isTrackedreport === "1");
                    const trackingStatus = allReportsCompleted ? 2 : (anyReportInProgress ? 1 : 0);
                    return (
                        <div key={report.id} className="tracking-group">
                            <div className="tracking-item wrap-text">
                                <div><h4>計畫名稱:{report.projectName}</h4> </div>
                                <div className="tracking-time-actions">
                                    <div className="tracking-time-row">
                                        <div>追蹤狀態: <StatusIndicator isTrackedreport={trackingStatus} /></div>
                                        <div className="tracking-time">追蹤時間: {report.projectStartTime} ~ {report.projectEndTime}</div>
                                    </div>
                                </div>
                                <div className="tracking-time-actions">
                                    <div className="tracking-time-row">
                                        <p className="tracking-time">建立追蹤人員: {report.build_id}</p>    </div>

                                    <div className="action-buttons">
                                        <Button
                                            className="btn btn-info"
                                            onClick={() => handleModifyreport(report.build_date, report.projectName)}
                                        >
                                            詳細資訊
                                        </Button>

                                    </div>
                                </div>
                            </div>

                        </div>
                    );
                })}

                <div className="pagination-controls">
                    <label>
                        Rows per page:
                        <select value={itemsPerPage} onChange={handleItemsPerPageChange} className="custom-select custom-select-sm">
                            {[10, 20, 30, 50].map(number => (
                                <option key={number} value={number}>{number}</option>
                            ))}
                        </select>
                    </label>
                    <span>
                        {`${Math.max(1, indexOfFirstGroup + 1)}-${Math.min(totalGroupCount, indexOfLastGroup)} of ${totalGroupCount}`}
                    </span>
                    <ul className='pagination'>
                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                            <button onClick={() => setCurrentPage(1)} className="page-link">««</button>
                        </li>
                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                            <button onClick={() => setCurrentPage(currentPage - 1)} className="page-link">«</button>
                        </li>
                        {Array.from({ length: totalPages }, (_, i) => i + 1).map(number => (
                            <li key={number} className={`page-item ${currentPage === number ? 'active' : ''}`}>
                                <button onClick={() => setCurrentPage(number)} className="page-link">
                                    {number}
                                </button>
                            </li>
                        ))}
                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                            <button onClick={() => setCurrentPage(currentPage + 1)} className="page-link">»</button>
                        </li>
                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                            <button onClick={() => setCurrentPage(totalPages)} className="page-link">»»</button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );



}

export default HistoryTrackingList;
